import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.enable-ai-banner.heading',
		defaultMessage: 'Activate Atlassian Intelligence',
		description:
			'Heading for banner displayed when the user is trying to create a virtual service agent but does not have AI Enabled.',
	},
	bodyIfSiteAdminV2: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.enable-ai-banner.body-if-site-admin-v-2',
		defaultMessage:
			'To use the virtual service agent, activate Atlassian Intelligence for Jira Service Management, then come back to this page to complete setup.',
		description:
			'Body for banner displayed when the user is a site admin and is trying to set up virtual service agent but does not have AI enabled.',
	},
	bodyIfSiteAdmin: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.enable-ai-banner.body-if-site-admin',
		defaultMessage:
			'To use the virtual agent, activate Atlassian Intelligence for Jira Service Management, then come back to this page to complete setup.',
		description:
			'Body for banner displayed when the user is a site admin and is trying to set up virtual agent but does not have AI enabled.',
	},
	bodyIfNotSiteAdminV2: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.enable-ai-banner.body-if-not-site-admin-v-2',
		defaultMessage:
			'To use the virtual service agent, your organization admin needs to activate Atlassian Intelligence for Jira Service Management.',
		description:
			'Body for banner displayed when the user is not a site admin and is trying to set up virtual service agent but does not have AI enabled.',
	},
	bodyIfNotSiteAdmin: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.enable-ai-banner.body-if-not-site-admin',
		defaultMessage:
			'To use the virtual agent, your organization admin needs to activate Atlassian Intelligence for Jira Service Management.',
		description:
			'Body for banner displayed when the user is not a site admin and is trying to set up virtual agent but does not have AI enabled.',
	},
	linkIfSiteAdmin: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.enable-ai-banner.link-if-site-admin',
		defaultMessage: '<link1>Activate</link1> ⋅ <link2>Find out more</link2>',
		description:
			'Link at the bottom of the banner that appears if user is a site admin and has set up a virtual service agent but does not have AI enabled.',
	},
	linkIfNotSiteAdmin: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.enable-ai-banner.link-if-not-site-admin',
		defaultMessage: '<link>Find out how to activate Atlassian Intelligence</link>',
		description:
			'Link at the bottom of the banner that appears if user is not site admin and has set up a virtual service agent but does not have AI enabled.',
	},
});
